import { render, staticRenderFns } from "./PatientMainView.vue?vue&type=template&id=6ca3d908"
import script from "./PatientMainView.vue?vue&type=script&lang=js"
export * from "./PatientMainView.vue?vue&type=script&lang=js"
import style0 from "./PatientMainView.vue?vue&type=style&index=0&id=6ca3d908&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports